import React from "react"
import { Snackbar, Box, Typography, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

interface SnackbarAlertProps {
    open: boolean
    message: string
    onClose: () => void
    icon?: React.ReactNode
}

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({ open, message, onClose, icon }) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={onClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(39, 38, 38, 0.8)",
                    color: "#fff",
                    padding: "12px 20px",
                    borderRadius: "8px",
                    boxShadow: 3,
                    gap: 1.5,
                }}
            >
                {/* Icon (if provided) */}
                {icon && <Box sx={{ display: "flex", alignItems: "center" }}>{icon}</Box>}

                {/* Message */}
                <Typography variant="body1" sx={{ flex: 1 }}>
                    {message}
                </Typography>

                {/* Close Button */}
                <IconButton onClick={onClose} sx={{ color: "#fff", padding: 0.5 }}>
                    <CloseIcon />
                </IconButton>
            </Box>
        </Snackbar>
    )
}

export default SnackbarAlert
